<template>
  <el-container class="layout-container">
    <el-aside width="220px" class="aside">
      <div class="logo">数据管理平台</div>
      <el-menu :default-active="$route.path" router background-color="#304156" text-color="#bfcbd9" active-text-color="#409EFF">
        <el-menu-item index="/dashboard">
          <i class="el-icon-s-data"></i><span>数据看板</span>
        </el-menu-item>
        <el-menu-item index="/data/import" v-if="canImportOrSuper">
          <i class="el-icon-upload2"></i><span>数据导入</span>
        </el-menu-item>
        <el-menu-item index="/user/manage" v-if="isAdmin">
          <i class="el-icon-user"></i><span>账号管理</span>
        </el-menu-item>
        <el-menu-item index="/commission/setting" v-if="isAdmin">
          <i class="el-icon-s-marketing"></i><span>分成设置</span>
        </el-menu-item>
        <el-menu-item index="/theater/manage" v-if="isAdmin">
          <i class="el-icon-s-grid"></i><span>剧场名称管理</span>
        </el-menu-item>
        <el-menu-item index="/team/manage" v-if="isAdmin">
          <i class="el-icon-s-cooperation"></i><span>团队分组管理</span>
        </el-menu-item>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header class="header">
        <span class="header-title">{{ currentTitle }}</span>
        <div class="header-right">
          <span class="user-info">{{ userInfo.nickname || userInfo.username }} ({{ roleLabel }})</span>
          <el-button type="text" @click="pwdDialog = true">修改密码</el-button>
          <el-button type="text" @click="handleLogout">退出</el-button>
        </div>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
    </el-container>

    <el-dialog title="修改密码" :visible.sync="pwdDialog" width="400px">
      <el-form ref="pwdForm" :model="pwdForm" :rules="pwdRules" label-width="100px">
        <el-form-item label="原密码" prop="oldPassword">
          <el-input v-model="pwdForm.oldPassword" type="password" show-password></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="pwdForm.newPassword" type="password" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="pwdForm.confirmPassword" type="password" show-password></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="pwdDialog = false">取消</el-button>
        <el-button type="primary" :loading="pwdLoading" @click="handleChangePassword">确认</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import api from '@/api'
export default {
  name: 'Layout',
  data() {
    const validateConfirm = (rule, value, callback) => {
      if (value !== this.pwdForm.newPassword) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    return {
      pwdDialog: false,
      pwdLoading: false,
      pwdForm: { oldPassword: '', newPassword: '', confirmPassword: '' },
      pwdRules: {
        oldPassword: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
        newPassword: [{ required: true, message: '请输入新密码', trigger: 'blur', min: 6 }],
        confirmPassword: [{ required: true, message: '请确认新密码', trigger: 'blur' }, { validator: validateConfirm, trigger: 'blur' }]
      }
    }
  },
  computed: {
    ...mapState(['userInfo']),
    ...mapGetters(['isSuperAdmin', 'isSubAdmin']),
    isAdmin() { return this.isSuperAdmin || this.isSubAdmin },
    canImportOrSuper() { return this.isSuperAdmin || (this.isSubAdmin && this.userInfo.canImport === 1) },
    roleLabel() {
      const map = { SUPER_ADMIN: '超级管理员', SUB_ADMIN: '分后台', USER: '查询用户' }
      return map[this.userInfo.roleType] || ''
    },
    currentTitle() {
      return this.$route.meta.title || ''
    }
  },
  methods: {
    handleLogout() {
      this.$store.commit('CLEAR_USER')
      this.$router.push('/login')
    },
    handleChangePassword() {
      this.$refs.pwdForm.validate(valid => {
        if (!valid) return
        this.pwdLoading = true
        api.changePassword({
          oldPassword: this.pwdForm.oldPassword,
          newPassword: this.pwdForm.newPassword
        }).then(() => {
          this.$message.success('密码修改成功')
          this.pwdDialog = false
          this.pwdForm = { oldPassword: '', newPassword: '', confirmPassword: '' }
        }).finally(() => { this.pwdLoading = false })
      })
    }
  }
}
</script>

<style scoped>
.layout-container { 
  height: 100vh; 
  background: #f5f7fa;
}

.aside { 
  background: linear-gradient(180deg, #1e293b 0%, #334155 100%);
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.1);
}

.logo {
  height: 64px; 
  line-height: 64px; 
  text-align: center;
  color: #fff; 
  font-size: 17px; 
  font-weight: 600;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(0, 0, 0, 0.1);
}

.el-menu {
  border-right: none;
  background: transparent;
}

.el-menu-item {
  border-radius: 0 8px 8px 0;
  margin: 4px 8px;
  transition: all 0.3s ease;
  color: #cbd5e1;
}

.el-menu-item:hover {
  background: rgba(102, 126, 234, 0.2);
  color: #fff;
}

.el-menu-item.is-active {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.3) 0%, rgba(118, 75, 162, 0.3) 100%);
  color: #fff;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.el-menu-item i {
  margin-right: 10px;
  font-size: 16px;
}

.header {
  background: #fff; 
  display: flex; 
  align-items: center;
  justify-content: space-between; 
  border-bottom: 1px solid #e2e8f0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  padding: 0 24px;
}

.header-title { 
  font-size: 19px; 
  font-weight: 600; 
  color: #1e293b;
}

.header-right { 
  display: flex; 
  align-items: center; 
  gap: 20px; 
}

.user-info { 
  font-size: 14px; 
  color: #64748b;
  padding: 8px 16px;
  background: #f1f5f9;
  border-radius: 20px;
}

.el-button--text {
  color: #64748b;
  font-size: 14px;
}

.el-button--text:hover {
  color: #667eea;
  background: rgba(102, 126, 234, 0.1);
}

.el-dialog {
  border-radius: 12px;
  overflow: hidden;
}

.el-dialog__header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 16px 24px;
}

.el-dialog__title {
  color: #fff;
  font-weight: 600;
}

.el-dialog__headerbtn .el-dialog__close {
  color: rgba(255, 255, 255, 0.8);
}

.el-dialog__body {
  padding: 24px;
}

.el-form-item__label {
  font-weight: 500;
  color: #475569;
}

.el-input__inner {
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  padding: 10px 14px;
}

.el-input__inner:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}
</style>
